<template>
  <div class="card p-1">
    <div class="card-body">
      <h5 class="card-title">Deposit Address</h5>
      <p v-if="networkLabel" class="text-light mb-3">
        Network: <strong>{{ networkLabel }}</strong>
      </p>

      <div
        class="row wallet-address px-2"
        v-if="walletAddress != '' && walletAddress != null"
      >
        <div class="row">
          <div class="col-md-8">
            <p class="text-light">
              Deposits to this address are unlimited. Note that you may not be
              able to withdraw all of your funds at once if you deposit more
              than your daily withdrawal limit.
            </p>
            <input
              type="text"
              class="form-control"
              :value="walletAddress"
              :id="`input_address_${currency}_${network || 'default'}`"
              readonly
            />
            <button
              type="button"
              class="btn btn-gradient mt-2"
              @click="copyAddressToClipboard"
            >
              Salin Alamat
            </button>
          </div>
          <div class="col-md-4 mt-4 mt-md-0">
            <qrcode-vue :value="walletAddress" :size="200" level="H" />
          </div>
        </div>
      </div>

      <button
        class="btn btn-outline-orange"
        v-else
        :disabled="isRequestingAddress"
        @click="requestAnAddress"
      >
        {{ isRequestingAddress ? "Loading..." : "Request an Address" }}
      </button>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import QrcodeVue from "qrcode.vue";
import { useToast } from "vue-toastification";
import themain from "@/applibs/themain.js";
import thestore from "@/applibs/thestore.js";
import { getWalletGroupLabel } from "@/applibs/walletGroupConfig.js";

const toast = useToast();

export default {
  components: {
    QrcodeVue,
  },
  props: {
    currency: {
      type: String,
      required: true,
    },
    network: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      themain,
      token: Cookies.get("jwt") || Cookies.get("usid"),
      walletAddress: "",
      isRequestingAddress: false,
    };
  },

  computed: {
    networkLabel() {
      return this.network ? getWalletGroupLabel(this.network) : "";
    },
  },

  async mounted() {
    await this.getWalletAddress();
  },

  methods: {
    async getWalletAddress() {
      var res = await thestore.getCipherbcWalletAddress(
        this.token,
        this.currency,
        this.network
      );
      if (res.success == true) {
        this.walletAddress = res.data.wallet_address;
      }
    },

    async requestAnAddress() {
      if (this.isRequestingAddress) {
        return;
      }

      this.isRequestingAddress = true;
      try {
        var res = await thestore.postRequestCipherbcAddress(
          this.token,
          this.currency,
          this.network
        );
        if (res.success == true) {
          this.walletAddress = res.data.wallet_address;
        } else {
          alert(res.msg);
        }
      } finally {
        this.isRequestingAddress = false;
      }
    },

    async copyAddressToClipboard() {
      const address = this.walletAddress;
      if (!address) {
        return;
      }

      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(address);
        } else {
          throw new Error("clipboard unavailable");
        }
        toast.success("Alamat berhasil disalin");
      } catch {
        const input = document.getElementById(
          `input_address_${this.currency}_${this.network || "default"}`
        );
        if (!input) {
          toast.error("Gagal menyalin alamat");
          return;
        }
        input.select();
        input.setSelectionRange(0, address.length);
        const copied = document.execCommand("copy");
        if (copied) {
          toast.success("Alamat berhasil disalin");
        } else {
          toast.error("Gagal menyalin alamat");
        }
      }
    },
  },
};
</script>

<style scoped>
.btn-outline-orange {
  color: #fedba1;
  border-color: #fedba1;
}
</style>
